import { useState, useEffect, useRef, useCallback } from "react";
import {
  Table,
  Button,
  TableHeader,
  StatusBadge,
  Icon,
  DisplayError,
  NoSearchResults,
  Dropdown,
  Avatar,
} from "@alpaca/framework";

import { Modal } from "antd";

import "./userTable.styles.scss";
import { Toast } from "@alpaca/framework";
import Settings from "../settings/settings.component";
import EditInvitationButton from "../../../components/editInvitation/editInvitation.component";
import EditButton from "../../../components/editUserButton/editUserButton.component";
import UserDelete from "../../../components/userDelete/userDelete.components";
import UserWindow from "../../../components/userUpdate/userUpdate.components";
import InvitationWindow from "../../../components/invitationWindow/invitationWindow.component";
import { checkPermission } from "../../../service/permission/permission";
import InviteUser from "../../../components/invite/invite.component";
import { connect } from "react-redux";
import { ClassSelector } from "../../../store/reduxSelector";
import _ from "lodash";
import { sieveObjectByKeys } from "../../../utils/sieveObject";
import { getAllProfile } from "../../../service/profile/profile";
import { UserCard } from "../../../components/userCard/UserCard";
import { getImpersonateService } from "./userTable.services";

function UserTable({ userInfo }) {
  const [users, setUsers] = useState([]);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [showForceCreate, setShowForceCreate] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [searchUser, setSearchUser] = useState("");
  const [errorInfo, setErrorInfo] = useState(null);
  const [displayView, setDisplayView] = useState(() => {
    return localStorage.getItem("displayView") || "cardView";
  });
  const toastRef = useRef();

  const handleEditClick = (user) => {
    setCurrentRecord(user);
    setShowUpdate(true);
  };

  const handleUserImpersonate = async (user) => {
    // update cookie
    await getImpersonateService({
      company_name: user.company_name,
      profile_name: user.profile_name,
    });
    // window.location.replace(`/${packageJson.homepage}`);
  };

  useEffect(() => {
    localStorage.setItem("displayView", displayView);
  }, [displayView]);

  const getAllProfiles = useCallback(() => {
    getAllProfile(userInfo?.company_name)
      .then((result) => {
        let processed = result.map((user) => {
          let premade = user.premade;
          if (
            user.profile_status === "Invite" &&
            premade &&
            premade.firstName &&
            premade.lastName
          ) {
            return {
              ...user,
              first_name: premade.firstName,
              last_name: premade.lastName,
            };
          }
          return user;
        });

        processed = processed.filter(
          (user) => user.profile_status !== "Disabled"
        );

        setUsers(processed);
        setErrorInfo(null);
      })
      .catch((error) => {
        setErrorInfo({
          headline: "Get User List Failed",
          description: error.message,
        });

        toastRef.current.open({
          title: "Get User List Failed",
          description: error.message,
          duration: 5,
          status: "error",
        });
      });
  }, [userInfo?.company_name]);

  useEffect(() => {
    getAllProfiles();
  }, [getAllProfiles]);

  const openModal = () => setShowModal(true);

  const onSend = () => {
    toastRef.current.open({
      title: "Record inserted",
      description: "your record has been inserted successfully",
      duration: 3,
      status: "success",
    });
    setShowModal(false);
  };

  const updateUser = (updatedUser) => {
    const _users = _.cloneDeep(users);
    const userIdx = _users.findIndex(
      (_user) =>
        _user.profile_name === updatedUser.profile_name &&
        _user.company_name === updatedUser.company_name
    );
    if (userIdx !== -1) {
      _users[userIdx] = {
        ..._users[userIdx],
        ...updatedUser,
      };
      setUsers(_users);
    }
  };

  const removeUser = (user) => {
    const _users = _.cloneDeep(users);
    const userIdx = _users.findIndex(
      (_user) =>
        _user.profile_name === user.profile_name &&
        _user.company_name === user.company_name
    );
    if (userIdx !== -1) {
      _users.splice(userIdx, 1);
      setUsers(_users);
    }
  };

  const cancelInvitation = (invitation) => {
    const _users = _.cloneDeep(users);
    const userIdx = _users.findIndex(
      (_user) =>
        _user.email_address === invitation.email_address &&
        _user.company_name === invitation.company_name &&
        !_user.profile_name
    );
    if (userIdx !== -1) {
      _users.splice(userIdx, 1);
      setUsers(_users);
    }
  };

  const resendInvitation = (invitation) => {
    const _users = _.cloneDeep(users);
    const userIdx = _users.findIndex(
      (_user) =>
        _user.email_address === invitation.email_address &&
        _user.company_name === invitation.company_name &&
        !_user.profile_name
    );
    if (userIdx !== -1) {
      _users[userIdx] = {
        ..._users[userIdx],
        ...invitation,
      };
      setUsers(_users);
    }
  };

  const forceCreateInvitation = (invitation) => {
    const _users = _.cloneDeep(users);
    const userIdx = _users.findIndex(
      (_user) =>
        _user.email_address === invitation.email_address &&
        _user.company_name === invitation.company_name &&
        !_user.profile_name
    );
    if (userIdx !== -1) {
      _users[userIdx] = {
        ..._users[userIdx],
        ...invitation,
      };
      setUsers(_users);
    }
  };

  const sendInvitation = (addData) => {
    const _users = _.cloneDeep(users);
    if (Array.isArray(addData)) {
      addData.forEach((ele) => {
        if (ele !== "") {
          const userIdx = _users.findIndex(
            (_user) =>
              _user.email_address === ele &&
              _user.company_name === userInfo?.company_name &&
              !_user.profile_name
          );
          if (userIdx === -1) {
            _users.push({
              email_address: ele,
              company_name: userInfo?.company_name || "",
              profile_status: "Invite",
              invited: userInfo?.profile_name || "",
            });
          } else {
            _users[userIdx] = {
              ..._users[userIdx],
              invited: userInfo?.profile_name || "",
            };
          }
        }
      });
    } else {
      const userIdx = _users.findIndex(
        (_user) =>
          _user.profile_name === addData.username &&
          _user.company_name === userInfo?.company_name
      );
      if (userIdx === -1) {
        _users.push({
          email_address: addData.email,
          company_name: userInfo?.company_name || "",
          first_name: addData.firstName,
          last_name: addData.lastName,
          profile_name: addData.username,
          profile_status: "Invite",
        });
      }
    }
    setUsers(_users);
  };

  const onFinish = ({ toast }) => {
    toastRef.current.open(toast);
    if (toast.status === "success") {
      setShowUpdate(false);
      setShowDelete(false);
      setShowCancel(false);
      setShowResend(false);
      setShowForceCreate(false);
    }
  };

  function createStatusColor(status) {
    switch (status) {
      case "inactive":
        return "#ec2027";
      case "active":
        return "#8cc640";
      default:
        return "#8c8c8c";
    }
  }

  function createStatusIcon(status) {
    switch (status) {
      case "inactive":
        return <Icon icon="close" />;
      case "active":
        return <Icon icon="check" />;
      default:
        return <Icon icon="question" />;
    }
  }

  const visibleUser = sieveObjectByKeys(users, searchUser, [
    "profile_name",
    "first_name",
    "last_name",
    "email_address",
  ]);

  const userTableColumns = [
    {
      title: "Name",
      dataIndex: "first_name",
      width: "25%",
      render: (value, record) => (
        <div className="userTableNameContainer">
          <div className="userTableAvatarContainer">
            <Avatar name={` ${record.first_name} ${record.last_name}`} />
          </div>
          <div className="userTableNameInfo">
            <span className="bodyTextLarge">
              {record.first_name} {record.last_name}
            </span>

            <a href={`mailto:${record.email_address}`}>
              <span className="bodyTextSmall linkText">
                {record.email_address}
              </span>
            </a>
          </div>
        </div>
      ),
    },

    {
      title: "Profile Name",
      dataIndex: "profile_name",
      sorter: (a, b) => a.profile_name?.localeCompare(b.profile_name),
      sortDirections: ["descend", "ascend"],
    },

    {
      title: "Invited By",
      dataIndex: "invited",
      key: "invited",
      sorter: (a, b) => a.invited?.localeCompare(b.invited),
      sortDirections: ["descend", "ascend"],
      onFilter: (value, record) => record.invited.includes(value),
    },
    {
      title: "Status",
      dataIndex: "profile_status",
      sorter: (a, b) => a.profile_status?.localeCompare(b.profile_status),
      sortDirections: ["descend", "ascend"],
      render: (text, record) => (
        <StatusBadge
          icon={createStatusIcon(text.toLowerCase())}
          name={text ? text : "NO STATUS"}
          color={createStatusColor(text.toLowerCase())}
        />
      ),
    },
    ...(!checkPermission("modify user")
      ? []
      : [
          {
            title: "Actions",
            fixed: "right",
            render: (_, record, index) =>
              record.profile_status === "Invite" ? (
                <EditInvitationButton
                  showCancelModal={() => {
                    setShowCancel(true);
                    setCurrentRecord(record);
                  }}
                  showResendModal={() => {
                    setShowResend(true);
                    setCurrentRecord(record);
                  }}
                  showForceCreateModal={() => {
                    setShowForceCreate(true);
                    setCurrentRecord(record);
                  }}
                ></EditInvitationButton>
              ) : (
                <EditButton
                  showEditModal={() => {
                    setShowUpdate(true);
                    setCurrentRecord(record);
                  }}
                />
              ),
          },
        ]),
  ];

  return (
    <div className="full-height">
      <Settings />
      <Toast ref={toastRef} />

      <div className="userListContentContainer">
        <TableHeader
          title={
            <div className="userTableHeader">
              <h2 className="pageTitle">User Management</h2>
              {checkPermission("Invite Users") && (
                <Button
                  type="primary"
                  size="large"
                  onClick={openModal}
                  icon={<Icon icon="user_add" />}
                >
                  Invite User
                </Button>
              )}
            </div>
          }
          showOptions={false}
          extraComponent={
            <div>
              <Dropdown
                size="large"
                menu={{
                  items: [
                    {
                      key: "1",
                      label: "Table View",
                      onClick: () => setDisplayView("tableView"),
                    },
                    {
                      key: "2",
                      label: "Card View",
                      onClick: () => setDisplayView("cardView"),
                    },
                  ],
                }}
              >
                <Button icon={<Icon icon="show" />} size="large">
                  Display Options
                </Button>
                {/* <Button icon={<Icon icon="filter" />} size="large">
                Filter
              </Button> */}
              </Dropdown>
            </div>
          }
          onChange={setSearchUser}
        />

        {/* FEEDBACK IMPORTANT */}
        {searchUser && visibleUser.length === 0 && !errorInfo && (
          <NoSearchResults />
        )}

        {errorInfo && (
          <DisplayError
            headline={errorInfo.headline}
            description={errorInfo.description}
            showAction={false}
          />
        )}

        {displayView === "cardView" ? (
          <div className="userCardGridContainer">
            {(visibleUser || []).map((user, index) => (
              <UserCard
                key={index}
                name={`${
                  user.first_name || user?.premade?.firstName || "Unnamed"
                } ${user.last_name || user?.premade?.lastName || "User"}`}
                email={user.email_address}
                profileName={user.profile_name}
                pending={user.profile_status === "Invite"}
                onEdit={() => handleEditClick(user)}
                onImpersonate={() => handleUserImpersonate(user)}
                setShowCancel={setShowCancel}
                setCurrentRecord={setCurrentRecord}
                setShowForceCreate={setShowForceCreate}
                setShowResend={setShowResend}
                record={user}
              />
            ))}
          </div>
        ) : (
          <div className="userTableContainer">
            <Table
              columns={userTableColumns}
              dataSource={visibleUser}
              className="newUserTable"
              pagination={false}
              scroll={{ y: `calc(100vh - 350px)`, x: 1000 }}
            />
          </div>
        )}
      </div>

      <InviteUser
        open={showModal}
        onCancel={() => setShowModal(false)}
        sendInvitation={sendInvitation}
      />

      <Modal
        open={showUpdate}
        mask="black"
        width={900}
        // height={750}
        onCancel={() => setShowUpdate(false)}
        title="Edit User"
        footer={null}
        centered
        className="userModal"
      >
        <UserWindow
          key={
            currentRecord?.email_address +
            currentRecord?.company_name +
            currentRecord?.profile_name
          }
          removeUser={removeUser}
          updateUser={updateUser}
          onClose={() => setShowUpdate(false)}
          rowData={currentRecord}
          onUpdate={onFinish}
        />
      </Modal>

      <Modal
        open={showDelete}
        mask="black"
        width={600}
        height={650}
        onCancel={() => setShowDelete(false)}
        title="Delete User"
      >
        <UserDelete
          removeUser={removeUser}
          onClose={() => setShowDelete(false)}
          rowData={currentRecord}
          onDelete={onFinish}
        />
      </Modal>

      <Modal
        open={showCancel}
        mask="black"
        width={400}
        height={425}
        onCancel={() => setShowCancel(false)}
        title="Cancel Invitation?"
        footer={null}
      >
        <InvitationWindow
          cancelInvitation={cancelInvitation}
          onClose={() => setShowCancel(false)}
          rowData={currentRecord}
          onFinish={onFinish}
        />
      </Modal>

      <Modal
        open={showResend}
        mask="black"
        width={400}
        height={425}
        onCancel={() => setShowResend(false)}
        title="Resend Invitation?"
        footer={null}
      >
        <InvitationWindow
          resendInvitation={resendInvitation}
          onClose={() => setShowResend(false)}
          rowData={currentRecord}
          onFinish={onFinish}
        />
      </Modal>

      <Modal
        open={showForceCreate}
        mask="black"
        width={500}
        height={750}
        onCancel={() => setShowForceCreate(false)}
        title="Force Create User"
        footer={null}
      >
        <InvitationWindow
          forceCreateInvitation={forceCreateInvitation}
          onClose={() => setShowForceCreate(false)}
          rowData={currentRecord}
          onFinish={onFinish}
        />
      </Modal>
    </div>
  );
}

const stateList = ["userInfo"];
export default connect((state) => ClassSelector(state, stateList))(UserTable);
